<div class="vs">
  <div class="vs-head">
    <h1>Статистика посетителей</h1>
    <p>Посещаемость сайта bilload.kz: страницы, города, источники и устройства.</p>
  </div>

  <!-- Фильтр периода — один ряд над графиками -->
  <div class="vs-toolbar">
    <div class="vs-seg" role="group" aria-label="Период">
      <button type="button" *ngFor="let p of periods" [class.active]="period === p.key" (click)="setPeriod(p.key)">{{ p.label }}</button>
    </div>
  </div>

  <!-- Состояния загрузки -->
  <div class="vs-state" *ngIf="loading && !summary" role="status">Загружаем статистику…</div>
  <div class="vs-state vs-state--error" *ngIf="error && !loading" role="alert">
    Не удалось загрузить статистику.
    <button type="button" class="vs-link" (click)="retry()">Повторить</button>
  </div>

  <ng-container *ngIf="summary && !error">
  <div class="vs-state" *ngIf="!hasData">
    За выбранный период просмотров пока нет. Данные появятся, когда на сайте включён сбор статистики и посетители открывают страницы.
  </div>

  <!-- ── Ключевые показатели ─────────────────────────────────────────── -->
  <div class="vs-kpis" [class.vs-loading]="loading">
    <div class="vs-kpi" *ngFor="let k of kpis" [title]="k.hint">
      <span class="vs-kpi__label">{{ k.label }}</span>
      <strong class="vs-kpi__value">{{ k.value }}</strong>
      <span class="vs-kpi__change" [class.down]="k.change !== null && !k.positive" *ngIf="k.change !== null; else noPrev">
        {{ k.change > 0 ? '▲ +' : k.change < 0 ? '▼ ' : '' }}{{ k.change }}{{ k.unit }} <small>к прошлому периоду</small>
      </span>
      <ng-template #noPrev><span class="vs-kpi__change vs-kpi__change--none"><small>нет данных за прошлый период</small></span></ng-template>
    </div>
  </div>

  <!-- ── Посетители по дням / часам ──────────────────────────────────── -->
  <section class="vs-card" [class.vs-loading]="loading">
    <h3>{{ chartTitle }}</h3>
    <div class="vs-chart" (mouseleave)="hover = null">
      <svg [attr.viewBox]="'0 0 ' + W + ' ' + H" preserveAspectRatio="none" role="img" [attr.aria-label]="chartTitle">
        <g class="vs-grid">
          <ng-container *ngFor="let g of gridLines">
            <line [attr.x1]="padL" [attr.x2]="W" [attr.y1]="H - padB - barH(g)" [attr.y2]="H - padB - barH(g)"></line>
          </ng-container>
        </g>
        <g>
          <path *ngFor="let b of chart; let i = index" class="vs-bar" [class.dim]="hover && hover.label !== b.label" [attr.d]="barPath(i, b.value)"></path>
        </g>
        <!-- Зоны наведения шире столбцов -->
        <rect *ngFor="let b of chart; let i = index" class="vs-hit" [attr.x]="padL + i * barStep" y="0" [attr.width]="barStep" [attr.height]="H - padB" (mouseenter)="onHover(i)"></rect>
      </svg>
      <div class="vs-axis-y">
        <span *ngFor="let g of gridLines" [style.bottom.%]="((barH(g) + padB) / H) * 100">{{ fmt(g) }}</span>
      </div>
      <div class="vs-axis-x">
        <ng-container *ngFor="let b of chart; let i = index">
          <span *ngIf="showLabel(i)" [style.left.%]="((barX(i) + barW / 2) / W) * 100">{{ b.label }}</span>
        </ng-container>
      </div>
      <div class="vs-tip" *ngIf="hover" [style.left.%]="hover.x">
        <span>{{ hover.label }}</span>
        <strong>{{ fmt(hover.value) }} посетителей</strong>
      </div>
    </div>
  </section>

  <div class="vs-grid2">
    <!-- ── Популярные страницы ────────────────────────────────────────── -->
    <section class="vs-card vs-wide">
      <h3>Популярные страницы</h3>
      <div class="vs-table-wrap">
        <table class="vs-table">
          <thead>
            <tr><th>Страница</th><th class="num">Просмотры</th><th class="num">Посетители</th><th class="num">Ср. время</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of pages">
              <td><span class="vs-page" *ngIf="p.title">{{ p.title }}</span><code>{{ p.path }}</code></td>
              <td class="num">{{ fmt(p.views) }}</td>
              <td class="num">{{ fmt(p.visitors) }}</td>
              <td class="num">{{ p.avgTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="vs-card">
      <h3>Города</h3>
      <ng-container *ngTemplateOutlet="shares; context: { $implicit: cities }"></ng-container>
    </section>

    <section class="vs-card">
      <h3>Источники переходов</h3>
      <ng-container *ngTemplateOutlet="shares; context: { $implicit: sources }"></ng-container>
    </section>

    <section class="vs-card">
      <h3>Устройства</h3>
      <ng-container *ngTemplateOutlet="shares; context: { $implicit: devices }"></ng-container>
      <h4>Браузеры</h4>
      <ng-container *ngTemplateOutlet="shares; context: { $implicit: browsers }"></ng-container>
    </section>

    <section class="vs-card">
      <h3>Язык сайта</h3>
      <ng-container *ngTemplateOutlet="shares; context: { $implicit: languages }"></ng-container>
      <h4>Рекламные ссылки (UTM)</h4>
      <ng-container *ngTemplateOutlet="shares; context: { $implicit: campaigns }"></ng-container>
    </section>

    <!-- ── Последние визиты ───────────────────────────────────────────── -->
    <section class="vs-card vs-wide">
      <h3>Последние визиты</h3>
      <div class="vs-table-wrap">
        <table class="vs-table">
          <thead>
            <tr><th>Время</th><th>Город</th><th>Устройство</th><th>Источник</th><th>Страница входа</th><th class="num">Страниц</th><th class="num">Длительность</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let v of visits">
              <td>{{ visitTime(v) }}</td>
              <td>{{ v.city || '—' }}</td>
              <td>{{ visitDevice(v) }}</td>
              <td>{{ v.source }}</td>
              <td><code>{{ v.entryPath }}</code></td>
              <td class="num">{{ v.pages }}</td>
              <td class="num">{{ visitDuration(v) }}</td>
            </tr>
            <tr *ngIf="visits.length === 0 && !visitsLoading"><td colspan="7" class="vs-empty">Визитов пока нет</td></tr>
          </tbody>
        </table>
      </div>
      <div class="vs-more">
        <span *ngIf="visits.length">Показано {{ visits.length }} из {{ fmt(visitsTotal) }}</span>
        <span class="vs-state vs-state--error vs-state--inline" *ngIf="visitsError">Не удалось загрузить визиты.</span>
        <button type="button" class="vs-btn" *ngIf="visitsHasNext || visitsError" [disabled]="visitsLoading" (click)="loadVisits(visitsError && visits.length === 0)">
          {{ visitsLoading ? 'Загружаем…' : visitsError ? 'Повторить' : 'Показать ещё' }}
        </button>
      </div>
    </section>
  </div>
  </ng-container>
</div>

<!-- Список долей: подпись, полоса, число и процент -->
<ng-template #shares let-list>
  <ul class="vs-shares">
    <li *ngFor="let s of list">
      <div class="vs-share__head">
        <span>{{ s.label }} <small *ngIf="s.hint">{{ s.hint }}</small></span>
        <span class="vs-share__num">{{ fmt(s.value) }} <small>{{ pct(s.value, list) }}%</small></span>
      </div>
      <div class="vs-share__track"><div class="vs-share__bar" [style.width.%]="(s.value / maxOf(list)) * 100"></div></div>
    </li>
  </ul>
</ng-template>
